import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';
import {fetchAllBis} from "../../catalog/infrastructure/CatalogService";

const FEATURED_PRODUCTS_FILTER = {
  characteristics: {
    featured: true
  }
};

export const FeaturedProducts = () => {
  const fetchFn = () =>
    fetchAllBis(FEATURED_PRODUCTS_FILTER, { amount: 50, page: 0 })
    .then(rd => mapRemoteData(rd, ({ content }) => content));
  return (
    <ProductSwiper title={'PRODUCTOS DESTACADOS'} fetchFn={fetchFn} />
  );
};
